function validateSigninPasswordlessForm(formEl, emailInputEl, emailErrorEl) {
    const form = document.querySelector(formEl);
    const emailInput = document.querySelector(emailInputEl);
    const emailError = document.querySelector(emailErrorEl);

    let emailDefaultState = true;

    $(emailInput).on('blur', function () {
        if ($(this).val() !== '' && emailDefaultState == true) {
            emailDefaultState = false;
            validateEmail(emailInput, emailError, 'The field is required');
        }
    });

    emailInput.addEventListener('change', () => {
        if (!emailDefaultState) {
            validateEmail(emailInput, emailError, 'The field is required');
        }
    });

    $(form).on('submit', function (e) {
        e.preventDefault();

        if (validateEmail(emailInput, emailError, 'The field is required')) {
            $(this)
                .off('submit')
                .on('submit', function () {
                    return true;
                });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });

    // $(form).on('submit', function (e) {
    //     e.preventDefault();

    //     if (validateEmail(emailInput, emailError, 'The field is required')) {
    //         $.ajax({
    //             url: $(this).attr('action'),
    //             method: 'POST',
    //             data: $(this).serialize(),
    //             success: function (response) {
    //                 alert('TICK');
    //                 console.log('Form submitted:', response);
    //             },
    //             error: function (xhr, status, error) {
    //                 console.error('Error:', error);
    //             },
    //         });
    //     } else {
    //         console.log('Validation failed');
    //     }
    // });
}

$(document).ready(function () {
    if ($('.js-signin-passwordless-form').length) {
        validateSigninPasswordlessForm(
            '.js-signin-passwordless-form',
            '.js-signin-passwordless-field',
            '.js-signin-passwordless-sign'
        );

        validateSigninPasswordlessForm(
            '.js-signup-passwordless-form',
            '.js-signup-passwordless-field',
            '.js-signup-passwordless-sign'
        );
    }
});
